import T from 'prop-types';
import React from 'react';
import { Select } from '@acast/decibel';
import { formatTime } from 'shared/helpers/time';
import Field from 'shared/components/field';
import { markerPropType } from '../../../../../../../customPropTypes';
import { getMarkerEndpoints } from '../../../../../../../shared/helpers/markers';

const SEPARATOR = '\u00A0\u00A0|\u00A0\u00A0';

function AdMarkerPositionRecommendations({
  episodeDuration,
  marker,
  markers,
  onChange,
  silenceDetected,
}) {
  const [minimumStartValue, maximumStartValue] = getMarkerEndpoints(
    markers,
    marker.id,
    episodeDuration
  );

  const createSelectOption = (midpoint, duration) => ({
    label: `${formatTime(midpoint)} ${SEPARATOR} duration: ${duration.toFixed(1)}s`,
    value: midpoint,
  });

  const silenceOptions = (silenceDetected || [])
    .map(({ duration, end }) => {
      const midpoint = end - duration * 0.5;

      if (midpoint < minimumStartValue || midpoint > maximumStartValue) {
        return null;
      }

      return createSelectOption(midpoint, duration);
    })
    .filter(item => !!item);

  const selectRecommendedStartTime = ({ target }) => {
    onChange(parseFloat(target.value));
  };

  const renderSelect = () => {
    const promptOption = {
      value: '',
      label: 'Pick a silence',
      disabled: true,
    };
    return (
      <Select value={marker.start} onChange={selectRecommendedStartTime}>
        {[promptOption].concat(silenceOptions).map(option => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    );
  };

  const renderNoSilencesFoundMessage = () => (
    <div className="ad-marker-position-recommendations__no-silences-found-message">
      <p>No suitable silences found.</p>
    </div>
  );

  return (
    <div className="ad-marker-position-recommendations">
      <Field
        label="Suggested Mid-Roll Position"
        name="recommended-position"
        help="Silences longer than 0.5 seconds detected in your show will be listed here as recommended mid-roll placements."
      >
        {silenceOptions.length > 0 ? renderSelect() : renderNoSilencesFoundMessage()}
      </Field>
    </div>
  );
}

AdMarkerPositionRecommendations.propTypes = {
  episodeDuration: T.number,
  marker: markerPropType,
  markers: T.arrayOf(markerPropType),
  onChange: T.func.isRequired,
  silenceDetected: T.arrayOf(
    T.shape({
      duration: T.number,
      end: T.number,
    })
  ),
};

export default AdMarkerPositionRecommendations;
